import React from 'react';
import { Plus, X, Upload, GripVertical } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';

const BannersTab = ({ settings, updateSetting, updateBanner, addBanner, removeBanner, uploadBannerImage }) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Kampanya Bannerları</CardTitle>
            <CardDescription>Ana sayfa slider bannerlarını düzenleyin</CardDescription>
          </div>
          <div className="flex items-center gap-2">
            <Switch
              checked={settings.banners_enabled}
              onCheckedChange={(v) => updateSetting('banners_enabled', v)}
            />
            <Button size="sm" variant="outline" onClick={addBanner}>
              <Plus className="w-4 h-4 mr-1" /> Banner Ekle
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {settings.banners?.map((banner, index) => (
            <div key={index} className="border rounded-lg p-4 relative group">
              <button
                onClick={() => removeBanner(index)}
                className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
              >
                <X className="w-4 h-4" />
              </button>
              
              <div className="flex items-start gap-4">
                <div className="cursor-move text-muted-foreground">
                  <GripVertical className="w-5 h-5" />
                </div>
                
                <div className="flex-1 grid md:grid-cols-2 gap-4">
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <Label>Aktif</Label>
                      <Switch
                        checked={banner.enabled}
                        onCheckedChange={(v) => updateBanner(index, 'enabled', v)}
                      />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs">Başlık</Label>
                      <Input
                        value={banner.title}
                        onChange={(e) => updateBanner(index, 'title', e.target.value)}
                        className="h-8 text-sm"
                      />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs">Alt Başlık</Label>
                      <Input
                        value={banner.subtitle}
                        onChange={(e) => updateBanner(index, 'subtitle', e.target.value)}
                        className="h-8 text-sm"
                      />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs">Buton Metni</Label>
                      <Input
                        value={banner.buttonText}
                        onChange={(e) => updateBanner(index, 'buttonText', e.target.value)}
                        className="h-8 text-sm"
                      />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-xs">Link</Label>
                      <Input
                        value={banner.link}
                        onChange={(e) => updateBanner(index, 'link', e.target.value)}
                        className="h-8 text-sm"
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="space-y-1">
                      <Label className="text-xs">Görsel URL</Label>
                      <div className="flex gap-2">
                        <Input
                          value={banner.image}
                          onChange={(e) => updateBanner(index, 'image', e.target.value)}
                          className="h-8 text-sm flex-1"
                        />
                        <Button 
                          size="sm" 
                          variant="outline"
                          className="h-8"
                          onClick={() => {
                            const input = document.createElement('input');
                            input.type = 'file';
                            input.accept = 'image/*';
                            input.onchange = (e) => {
                              const file = e.target.files[0];
                              if (file && uploadBannerImage) {
                                uploadBannerImage(file, index);
                              }
                            };
                            input.click();
                          }}
                        >
                          <Upload className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                    {banner.image && (
                      <div className="relative rounded-lg overflow-hidden bg-gray-100">
                        <img 
                          src={banner.image} 
                          alt={banner.title}
                          className="w-full h-32 object-cover"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default BannersTab;
